import React from 'react';
class Auth extends React.Component{
    render(){
        return <div>hi</div>;
    }
}
export default Auth;


// WEBPACK FOOTER //
// ./src/Auth.js